import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import WaiverTab from "../../HomeSettingPage/WaiverTab";

const Step6Waivers = ({
  wizardData,
  setWizardData,
  registrationID,
  settingInfo,
}) => {
  return (
    <div className="wizard-step-card">
      <h3 className="wizard-step-title">Waivers</h3>
      <p className="wizard-step-description">
        Set up liability waivers and terms that participants must agree to during
        registration.
      </p>

      <div className="wizard-info-box" style={{ marginBottom: 24 }}>
        <p>
          <InfoCircleOutlined style={{ marginRight: 8 }} />
          This step is optional for the wizard. You can skip it now and add
          waivers later using the "Waivers" tab in manual mode.
        </p>
      </div>

      {/* Embed the WaiverTab component */}
      <WaiverTab
        registrationID={registrationID}
        setRegistrationID={() => {}}
        settingInfo={settingInfo}
        hideActionButtons={true}
      />
    </div>
  );
};

export default Step6Waivers;
